<template>
  <div class="w-100 h-100">
    <dv-border-box-7 style="vertical-align: middle">
      <div style="font-size:24px;margin:0.2rem 0px 10px 10px;font-weight:bold;">问题点分布</div>
      <div id="jobContent" style="width: 100%;height:100%;">
        <el-row :gutter="24">
          <el-col :span="6">
            <div :style="{ 'width': jWeight + 'px', 'height': jHeight + 'px' }" id="jobFiex"></div>
          </el-col>
          <el-col :span="18">
            <carousel :perPage="3" :loop="true" :paginationEnabled="false" :scrollPerPage="false" :autoplay="true">
              <template v-for="(item, i) in totals">
                <slide :key="item.departmentId" v-if="i > 0">
                  <div :style="{ 'width': jWeight + 'px', 'height': jHeight + 'px' }" @click="viewPlanList(item)"
                    :id="'job-' + i"></div>
                </slide>
              </template>
            </carousel>
          </el-col>
        </el-row>
      </div>
      <div class="tooltip-container">
        <el-tooltip effect="dark" content="最近一年问题统计，按问题创建时间查询，显示各部门问题总数、逾期未完成、期限内未完成等，按责任人部门分组显示。" placement="top-start">
          <i class="el-icon-question" style="font-size:16px;"></i>
        </el-tooltip>
      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
import parse from "date-fns/fp/parse/index";
export default {
  name: "lpa-progress",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      totals: this.beans,
      startCharts: null,
      jWeight: 0,
      jHeight: 0
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.totals = val;
        var _this = this;
        this.$nextTick(() => {
          _this.pieEchart();
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.documentWH();
  },
  methods: {
    documentWH() {
      var parent = document.getElementById("jobContent");
      var width = parent.clientWidth;
      var height = parent.clientHeight-60;
      this.jWeight = parseInt(width / 4)-10;
      this.jHeight = height;
    },
    dataSlice(index, data) {
      return data.slice(index);
    },
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
    pieEchart() {
      var _this = this;
      var datas = this.totals;
      for (var i = 0; i < datas.length; i++) {
        var data = datas[i];
        var title = data["departmentTitle"];
        var actualCount = data["actualCount"]; //已关闭
        var planExpiredCount = data["planExpiredCount"];//延期未关闭
        var total = data["plannedCount"]; //所有问题

        var unTotal = total - actualCount - planExpiredCount;// 计划内未关闭的

        var option = {
          // 标题组件，包含主标题和副标题
          title: {
            show: true,
            x: "center",
            textStyle: {
              fontSize: "22",
              color: "#FFFFFF",
              fontWeight: "bold",
            },
          },
          //  提示框组件
          tooltip: {
            //是否显示提示框组件，包括提示框浮层和 axisPointe
            show: false,
            // 触发类型: item:数据项触发，axis：坐标轴触发
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)",
          },

          series: [
            {
              // 系列名称，用于tooltip的显示，legend 的图例筛选，在 setOption 更新数据和配置项时用于指定对应的系列。
              name: "任务进度",
              type: "pie",
              // 饼图的半径，数组的第一项是内半径，第二项是外半径
              radius: ["100%", "80%"],
              // 是否启用防止标签重叠策略，默认开启
              avoidLabelOverlap: false,
              hoverAnimation: false,
              // 标签的视觉引导线样式，在 label 位置 设置为'outside'的时候会显示视觉引导线
              labelLine: {
                normal: {
                  show: false,
                },
              },
              data: [
                {
                  // 数据值
                  value: actualCount,
                  // 数据项名称
                  name: title,
                  //该数据项是否被选中
                  selected: false,
                  itemStyle: { color: "#00CD66" },
                  // 单个扇区的标签配置
                  label: {
                    normal: {
                      // 是显示标签
                      show: true,
                      position: "center",
                      fontSize: '15',
                      color: "#FFFFFF",
                      // 标签内容格式器，支持字符串模板和回调函数两种形式，字符串模板与回调函数返回的字符串均支持用 \n 换行
                      formatter: function (val) {
                        return (
                          title +
                          "\n\n期限内未关闭：" +
                          unTotal +
                          "\n\n逾期未关闭：" +
                          planExpiredCount +
                          "\t" +
                          "\n\n问题点总数：" +
                          total
                        );
                      },
                    },
                  },
                },
                {
                  value: unTotal,
                  label: {
                    normal: {
                      show: false,
                    },
                  },
                  itemStyle: { color: "#FFcc99" },
                },
                {
                  value: planExpiredCount,
                  label: {
                    normal: {
                      show: false,
                    },
                  },
                  itemStyle: { color: "red" },
                },
              ],
            },
          ],
        };

        if (i == 0) {
          //第一个固定
          var pipeo = this.$echarts.init(document.getElementById("jobFiex"));
          pipeo.setOption(option);
        } else {
          var pipe1 = this.$echarts.init(document.getElementById("job-" + i));
          pipe1.setOption(option);
        }
      }

    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>


<style scoped>
#borderStyle {
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  white-space: nowrap;
  float: left;
  text-align: center;
  scroll-behavior: smooth;
}

.scropDiv {
  position: relative;
  display: inline-block;
}
.tooltip-container {
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/ehs/component/job-total.vue